import React from "react";
import Banner from "../../components/Banner/Banner";
import ContactOne from "../../components/Contact/ContactOne";
import InvestmentDrivers from "../../components/InvestmentDrivers/InvestmentDrivers";
import Roadmap from "../../components/Roadmap/Roadmap";
import RoadmapStats from "../../components/RoadmapStats/RoadmapStats";
import Megaprojects from "../../components/Megaprojects/Megaprojects";
import FamousResidents from "../../components/FamousResidents/FamousResidents";
import DubaiVsBudapest from "../../components/DubaiVsBudapest/DubaiVsBudapest";
import Sales from "../../components/Sales/Sales";
import TeamOne from "../../components/Team/TeamOne";
import TopPartners from "../../components/TopPartners/TopPartners";
import WhitePaper from "../../components/WhitePaper/WhitePaper";
import WhoWeAre from "../../components/WhoWeAre/WhoWeAre";
import OurMission from "../../components/WhoWeAre/OurMission";
import WhyChooseUs from "../../components/WhyChooseUs/WhyChooseUs";
import LayoutOne from "../../layouts/LayoutOne";

const Home = () => {
  return (
    <LayoutOne>
      <main className="fix">
        <Banner />

        <WhyChooseUs />

        <InvestmentDrivers />

        <Roadmap />

        <RoadmapStats />

        <Megaprojects />

        <FamousResidents />

        <DubaiVsBudapest />

        {/* <WhoWeAre />

        <OurMission />

        {/* <TopPartners /> */}
        {/* <Sales /> */}

         {/*<div className="area-bg">
          <Roadmap />
          <WhitePaper />
        </div> */}

        <ContactOne />
      </main>
    </LayoutOne>
  );
};

export default Home;
